import cookie from 'js-cookie';
import { ConfigProps, ServerConfig } from '../../types/requestTypes';

export function getServerConfig(config: ConfigProps): ServerConfig {
    return {
        endpoints: config.customerEngage.endpoints,
        headers: {
            'X-Top-Appname': config.appName,
            'X-Top-Host': config.endpointConfig.wso2host,
            'X-Top-Port': '80',
            Authorization: `Bearer ${cookie.get('jwt')}`,
            ...config.customerEngage.headers
        }
    } as ServerConfig;
}
